import actions from './actions';

const initialState = {
    urlFacturas: '',
    isDownloaded: false,

    urlVentas: "",
    isVentasDownloaded: false,

    urlCartera: "",
    isCarteraDownloaded: false,

    urlRemisiones: '',
    isRemisionesDownloaded: false,

    urlInformeCompras: '',
    isInformeComptasDownloaded: false,

    urlIngresosEfectivo: '',
    isIngresosEfectivoDownloaded: false,
    urlIngresosDavivienda: '',
    isIngresosDaviviendaDownloaded: false,
    urlIngresosBancolombia: '',
    isIngresosBancolombiaDownloaded: false,
    urlIngresosCajaCodice: '',
    isIngresosCajaCodiceDownloaded: false,

    urlEgresosCajaCodice: '',
    isEgresosCajaCodiceDownloaded: false,
    urlEgresosEfectivo: '',
    isEgresosEfectivoDownloaded: false,
    urlEgresosDavivienda: '',
    isEgresosDaviviendaDownloaded: false,
    urlEgresosBancolombia: '',
    isEgresosBancolombiaDownloaded: false,

    urlEgresosCompras: '',
    isEgresosComprasDownloaded: false,

    urlIngresosEfectivoTusCupos: '',
    isIngresosEfectivoTusCuposDownloaded: false,
    urlIngresosCajaTusCupos: '',
    isIngresosCajaTusCuposDownloaded: false,
    urlEgresosEfectivoTusCupos: '',
    isEgresosEfectivoTusCuposDownloaded: false,
    urlEgresosCajaTusCupos: '',
    isEgresosCajaTusCuposDownloaded: false,

};

export default function userReducer(state = initialState, action) {
    switch (action.type) {
        case actions.DOWNLOAD_FACTURAS_SUCCESS:
            return {
                ...state,
                urlFacturas: action.payload,
                isDownloaded: true,
            }
        case actions.DOWNLOAD_INFORME_CARTERA_SUCCESS:
            return {
                ...state,
                urlCartera: action.payload,
                isCarteraDownloaded: true,
            }
        case actions.DOWNLOAD_INFORME_VENTAS_SUCCESS:
            return {
                ...state,
                urlVentas: action.payload,
                isVentasDownloaded: true,
            }
        case actions.DOWNLOAD_REMISIONES_SUCCESS:
            return {
                ...state,
                urlRemisiones: action.payload,
                isRemisionesDownloaded: true,
            }
        case actions.DOWNLOAD_INFORME_COMPRAS_SUCCESS:
            return {
                ...state,
                urlInformeCompras: action.payload,
                isInformeComptasDownloaded: true,
            }
        case actions.INGRESOS_EFECTIVO:
            return {
                ...state,
                urlIngresosEfectivo: action.payload,
                isIngresosEfectivoDownloaded: true,
            }
        case actions.INGRESOS_DAVIVIENDA:
            return {
                ...state,
                urlIngresosDavivienda: action.payload,
                isIngresosDaviviendaDownloaded: true,
            }
        case actions.INGRESOS_BANCOLOMBIA:
            return {
                ...state,
                urlIngresosBancolombia: action.payload,
                isIngresosBancolombiaDownloaded: true,
            }
        case actions.INGRESOS_CAJA_CODICE:
            return {
                ...state,
                urlIngresosCajaCodice: action.payload,
                isIngresosCajaCodiceDownloaded: true,
            }
        case actions.EGRESOS_EFECTIVO:
            return {
                ...state,
                urlEgresosEfectivo: action.payload,
                isEgresosEfectivoDownloaded: true,
            }
        case actions.EGRESOS_DAVIVIENDA:
            return {
                ...state,
                urlEgresosDavivienda: action.payload,
                isEgresosDaviviendaDownloaded: true,
            }
        case actions.EGRESOS_BANCOLOMBIA:
            return {
                ...state,
                urlEgresosBancolombia: action.payload,
                isEgresosBancolombiaDownloaded: true,
            }
        case actions.EGRESOS_COMPRAS:
            return {
                ...state,
                urlEgresosCompras: action.payload,
                isEgresosComprasDownloaded: true,
            }
        case actions.EGRESOS_CAJA_CODICE:
            return {
                ...state,
                urlEgresosCajaCodice: action.payload,
                isEgresosCajaCodiceDownloaded: true,
            }
        case actions.INGRESOS_EFECTIVO_TUS_CUPOS:
            return {
                ...state,
                urlIngresosEfectivoTusCupos: action.payload,
                isIngresosEfectivoTusCuposDownloaded: true,
            }
        case actions.INGRESOS_CAJA_TUS_CUPOS:
            return {
                ...state,
                urlIngresosCajaTusCupos: action.payload,
                isIngresosCajaTusCuposDownloaded: true,
            }
        case actions.EGRESOS_EFECTIVO_TUS_CUPOS:
            return {
                ...state,
                urlEgresosEfectivoTusCupos: action.payload,
                isEgresosEfectivoTusCuposDownloaded: true,
            }
        case actions.EGRESOS_CAJA_TUS_CUPOS:
            return {
                ...state,
                urlEgresosCajaTusCupos: action.payload,
                isEgresosCajaTusCuposDownloaded: true,
            }
        case actions.RESET_DOWNLOAD_FACTURAS:
            return initialState;
        default:
            return state;
    }

}
